export default "__VITE_ASSET__GSpbW244__"